import { useApp } from '@/context/AppContext';
import Toast from '@/components/ui/Toast';
import Modal from '@/components/ui/Modal';
import SyncIndicator from '@/components/ui/SyncIndicator';
import UserMenu from '@/components/ui/UserMenu';
import Dashboard  from '@/screens/desktop/Dashboard';
import Customers  from '@/screens/desktop/Customers';
import Routes     from '@/screens/desktop/Routes';
import Billing    from '@/screens/desktop/Billing';
import Team       from '@/screens/desktop/Team';
import Settings   from '@/screens/desktop/Settings';

const NAV_ITEMS = [
  { id: 'dashboard', icon: '⚡',  label: 'Overview'  },
  { id: 'routes',    icon: '🗺️',  label: 'Routes'    },
  { id: 'customers', icon: '👤',  label: 'Customers' },
  { id: 'billing',   icon: '💳',  label: 'Billing'   },
  { id: 'team',      icon: '👥',  label: 'Team'      },
  { id: 'settings',  icon: '⚙️',  label: 'Settings'  },
];

const SCREEN_MAP = {
  dashboard: Dashboard,
  customers: Customers,
  routes:    Routes,
  billing:   Billing,
  team:      Team,
  settings:  Settings,
};

export default function DesktopLayout() {
  const { screen, setScreen, invoices, todayStops, setForceView } = useApp();

  const overdueCount = invoices.filter(i => i.status === 'overdue').length;
  const activeCount  = todayStops.filter(s => s.status === 'active').length;

  function getBadge(id) {
    if (id === 'billing' && overdueCount > 0) return overdueCount;
    if (id === 'routes'  && activeCount  > 0) return activeCount;
    return null;
  }

  const CurrentScreen = SCREEN_MAP[screen] || Dashboard;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Topbar */}
      <div className="topbar">
        <button className="wordmark" onClick={() => setScreen('dashboard')} style={{ border: 'none', background: 'transparent', padding: 0 }}>
          <div className="wmark">W</div>
          PainterOps
        </button>

        <nav className="topnav">
          {NAV_ITEMS.map(n => (
            <button
              key={n.id}
              className={`tnb${screen === n.id ? ' active' : ''}`}
              onClick={() => setScreen(n.id)}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="topright">
          <SyncIndicator />
          <button
            className="view-toggle"
            onClick={() => setForceView('mobile')}
          >
            Mobile View
          </button>
          <UserMenu initials="MR" />
        </div>
      </div>

      {/* Body */}
      <div className="app-body">
        {/* Sidebar */}
        <nav className="sidebar">
          <div className="slabel">Today</div>
          {NAV_ITEMS.slice(0, 2).map(n => {
            const badge = getBadge(n.id);
            return (
              <button
                key={n.id}
                className={`si${screen === n.id ? ' active' : ''}`}
                onClick={() => setScreen(n.id)}
              >
                <span className="ico">{n.icon}</span>
                {n.label}
                {badge != null && (
                  <span className="badge" style={{ background: 'var(--cyan-t)', color: 'var(--cyan)' }}>
                    {badge}
                  </span>
                )}
              </button>
            );
          })}

          <div className="slabel">Manage</div>
          {NAV_ITEMS.slice(2).map(n => {
            const badge = getBadge(n.id);
            return (
              <button
                key={n.id}
                className={`si${screen === n.id ? ' active' : ''}`}
                onClick={() => setScreen(n.id)}
              >
                <span className="ico">{n.icon}</span>
                {n.label}
                {badge != null && (
                  <span className="badge" style={{ background: 'var(--rose-t)', color: 'var(--rose)' }}>
                    {badge}
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        {/* Main content */}
        <main className="main">
          <CurrentScreen />
        </main>
      </div>

      {/* Global overlays */}
      <Modal />
      <Toast />
    </div>
  );
}
